<template>
  <div id="main-wrapper">
    <!-- delete account popup -->
    <div v-if="store.trans_id && store.trans_id_type == 'DISABLE ACCOUNT'">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <img src="assets/images/warning.png" alt=""><br>
                <p>{{$t('account.attention')}} {{store.lastSelectedAccount.account_id}}.
                  <br><br>
                  {{$t('account.note_after_requesting')}}
                  <br><br>
                  {{$t('account.after_clicking')}}
                  <SuccessBox
                    type="delete"
                  />
                </p>
              </div>
              <!-- <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="deleteAccount()">Confirm </a>
              </div> -->
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="resetAndBack">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="message">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p>{{message}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="(msgType == 'error')?message = false : ChangeTradingAcc();message = false">{{$t('account.ok')}} </a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="(msgType == 'error')?message = false : ChangeTradingAcc();message = false">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-container profile-page manage-acct">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="content-holder manage-form-holder">
              <div class="row-sec">
                <div class="form-holder wow fadeInLeft">
                  <ul class="clearfix">
                    <li class="half-width f-left">
                      <!-- <label class="float-label">Account</label> -->
                      <!-- <Field
                        class="form-control"
                        name="account"
                        rules="required"
                        v-model="store.lastSelectedAccount.account_id"
                        v-slot="{ field }"
                      >
                        <AccountsDropdown v-bind="field" />
                      </Field> -->
                        <select class="drop-search" name="account" v-model="store.lastSelectedAccount.account_id"  @change="GetTradingAccountDetail">
                            <option value="" label="Select Trading ID">{{$t('account.select_trading_id')}}</option>
                            <optgroup label="Demo MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Demo MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('0','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT4">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live MT5">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                            <optgroup label="Live ZTP">
                              <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                            </optgroup>
                           
                        </select>
                    </li>
                    <li class="half-width f-right">
                      <Field
                        class="form-control float-field" 
                        name="currency"
                        rules="required"
                        v-model="store.lastSelectedAccount.currency"
                        placehold=" "
                        disabled
                      />
                      <label class="float-label">{{$t('account.currency')}}</label>
                    </li>
                    <li class="half-width f-left">
                      <Field
                        class="form-control float-field"
                        name="account_type"
                        rules="required"
                        v-model="store.lastSelectedAccount.account_type"
                        placehold=" "
                        disabled
                      />
                      <label class="float-label">{{$t('account.Account_Type')}}</label>
                    </li>
                    <li class="half-width f-right">
                      <Field
                        class="form-control float-field"
                        name="balance"
                        rules="required"
                        v-model="
                          store.tradingAccountDetail.margin_detail.balance
                        "
                        placehold=" "
                        disabled
                      />
                      <label class="float-label">{{$t('account.balance')}}</label>
                    </li>
                    <li class="half-width f-left">
                      <Field
                        class="form-control float-field"
                        name="label"
                        rules="required"
                        v-model="store.lastSelectedAccount.label"
                        placehold=" "
                        disabled
                      />
                      <label class="float-label">{{$t('account.Account_Label')}}</label>
                    </li>
                    <li class="half-width f-right">
                      <Field
                        class="form-control float-field"
                        name="bonus"
                        rules="required"
                        v-model="
                          store.tradingAccountDetail.margin_detail.credit
                        "
                        placehold=" "
                        disabled
                      />
                      <label class="float-label">{{$t('account.Bonus')}}</label>
                    </li>
                    <li class="half-width f-left">
                      <Field
                        class="form-control float-field"
                        name="leverage"
                        rules="required"
                        v-model="store.lastSelectedAccount.leverage"
                        placehold=" "
                        disabled
                      />
                      <label class="float-label">{{$t('account.Leverage')}}</label>
                    </li>
                    <li class="half-width f-right">
                      <Field
                        class="form-control float-field"
                        name="equity"
                        rules="required"
                        v-model="
                          store.tradingAccountDetail.margin_detail.equity
                        "
                        placehold=" "
                        disabled
                      />
                      <label class="float-label">{{$t('account.Equity')}}</label>
                    </li>
                  </ul>
                  <div class="btn-holder t-center">
                    <router-link :to="{ name: 'Create Account', query: { type: 'demo' } }" class="btn btn-link">
                      <img src="assets/images/man-ico1.png" alt="" />{{$t('account.Create_Demo_Account')}}
                    </router-link>
                    <router-link :to="{ name: 'Create Account', query: { type: 'live' } }" class="btn btn-link">
                      <img src="assets/images/man-ico1.png" alt="" />{{$t('account.Create_Live_Account')}}
                    </router-link>
                    <router-link to="/internal-transfer" class="btn btn-link"
                      :class="(store.tradingAccounts.records.length == 0) ? 'disabled' : ''" ><img src="assets/images/man-ico6.png" alt="" /> {{$t('account.internal_transfer_CAP')}}</router-link
                    >
                  </div>
                </div>
                <div class="btn-sideholder wow fadeInRight">

                  <router-link to="/web-trader" target="_blank" class="btn btn-link" :class="(store.tradingAccounts.records.length == 0) ? 'disabled' : ''" v-if="store.lastSelectedAccount.platform && store.lastSelectedAccount.platform.toLowerCase() == 'mt4'"><img src="assets/images/man-ico3.png" alt=""/> {{$t('account.web_trading')}}
                  </router-link>
                  
                  <a href="https://mt5server.aaafx.com/terminal" target="_blank" class="btn btn-link" :class="(store.tradingAccounts.records.length == 0) ? 'disabled' : ''" v-if="store.lastSelectedAccount.platform && store.lastSelectedAccount.platform.toLowerCase() == 'mt5' && store.lastSelectedAccount.demo_live"><img src="assets/images/man-ico3.png" alt=""/> {{$t('account.web_trading')}}
                  </a>
                  <a href="https://mt5demo.aaafx.com/terminal" target="_blank" class="btn btn-link" :class="(store.tradingAccounts.records.length == 0) ? 'disabled' : ''" v-else-if="store.lastSelectedAccount.platform && store.lastSelectedAccount.platform.toLowerCase() == 'mt5'"><img src="assets/images/man-ico3.png" alt=""/> {{$t('account.web_trading')}}
                  </a>

                  <router-link to="/add-label" class="btn btn-link"
                    :class="(store.tradingAccounts.records.length == 0) ? 'disabled' : ''" ><img src="assets/images/man-ico4.png" alt="" /> {{$t('account.add_account_label_CAP')}}</router-link
                  >
                  <router-link to="/change-acct-leverage" class="btn btn-link"
                    :class="(store.tradingAccounts.records.length == 0) ? 'disabled' : ''" ><img src="assets/images/man-ico5.png" alt="" /> {{$t('account.change_laverage')}}</router-link
                  >
                 <!--  {{ store.lastSelectedAccount }} -->
                  <button
                    class="btn btn-link popup-link-holder del-btn"
                    :title = "(parseInt(store.tradingAccountDetail.margin_detail.balance) > 0 && store.lastSelectedAccount.demo_live == 1) ? 'you have balance in trading account' : ''"
                    :disabled = "(store.tradingAccounts.records.length == 0 || (parseInt(store.tradingAccountDetail.margin_detail.balance) > 0 && store.lastSelectedAccount.demo_live == 1)) ? true : false"
                    @click.prevent="deleteaccount"
                    :class="(store.tradingAccounts.records.length == 0 || (parseInt(store.tradingAccountDetail.margin_detail.balance) > 0 && store.lastSelectedAccount.demo_live == 1)) ? 'disabled' : ''" ><img src="assets/images/man-ico2.png" alt="" /> {{$t('account.delete_account')}}</button>
                  <router-link to="/reset-trading-pass" class="btn btn-link"
                    :class="(store.tradingAccounts.records.length == 0) ? 'disabled' : ''" ><img src="assets/images/man-ico7.png" alt="" /> {{$t('account.reset_trading_password')}}</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Field } from "vee-validate";
//import AccountsDropdown from "@/components/shared/AccountsDropdown";
import SuccessBox from "@/components/shared/SuccessBox";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      form: {
        from_account_id: "",
        to_account_id: "",
        amount: "",
        operation: "DISABLE ACCOUNT",
      },
      success : false,
      openPopup : false,
      message : null,
      msgType : ''
    };
  },
  mounted() {
    this.form.account_id = this.store.lastSelectedAccount.account_id;
    this.form.currentLeverage = this.store.lastSelectedAccount.leverage;
  },
  components: {
    Field,
    SuccessBox,
    //AccountsDropdown,
  },
  
  methods: {
    // selectTradingAccount(e) {
    //   let acct = this.store.tradingAccounts.records.find(
    //     (i) => i.account_id == e.target.value
    //   );
    //   this.store.setLastSelectedAccount(acct);
    // },
    deleteaccount(){
      let form ={
         "account_id": this.store.lastSelectedAccount.account_id,
          "act_account_id": this.store.lastSelectedAccount.act_account_id,
          "operation": "DISABLE ACCOUNT"
      }
      this.store.accountOperations(form, true);
    },
    MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    resetAndBack() {
      this.store.$patch({ trans_id: null });
    },
    GetTradingAccountDetail(e){
      let acct = this.store.tradingAccounts.records.find(
        (i) => i.account_id == e.target.value
      );
      let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
      this.store.setLastSelectedAccount(acct, keys,false,'');
    },
    ChangeTradingAcc(){
      this.store.tradingAccounts.records = this.store.tradingAccounts.records.filter(val => val.account_id != this.store.lastSelectedAccount.account_id)

      let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
      this.store.setLastSelectedAccount(this.store.tradingAccounts.records[0], keys,false,'');
    },
    verify() {
      let form = {
        type: this.form.operation,
        google_token: this.google_token,
        trans_id: `${this.store.trans_id}`,
        trading_id : this.store.lastSelectedAccount.account_id
      };
      this.store.verifyAccountOperation(form, true).then(() => {
        //modal show
        this.store.$patch({ trans_id: null });
        this.message = 'Your trading account has been deleted successfully'
        this.msgType = 'success'
      }).catch(error => {
        this.store.$patch({ trans_id: null });
        this.message = error
        this.msgType = 'error'
      })
      this.google_token = ''
    },
  },
};
</script>
